import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getCertificateAuth({ commit }, key) {
      try {
        const response = await api.get(`/certificate/auth?key=${key}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
